import apiClient from "@/app/api/client";
import type { Setting, SettingValue } from "../types";

interface SettingListResponse {
	success: true;
	data: Setting[];
}

interface SingleSettingResponse {
	success: true;
	data: Setting;
}

export const settingsService = {
	async list(): Promise<Setting[]> {
		const response = await apiClient.get<SettingListResponse>("/settings");
		return response.data.data;
	},

	/**
	 * Qiymat `jsonb` — tip kalitga bog'liq. Backend `SettingUpdateSchema`
	 * `string | number | boolean` birlashmasini kutadi (`null` ham,
	 * `undefined` ham qabul qilinmaydi).
	 */
	async update(key: string, value: SettingValue): Promise<Setting> {
		const response = await apiClient.patch<SingleSettingResponse>(`/settings/${key}`, { value });
		return response.data.data;
	},
};
